/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamProgramovaInstance extends GContentBase<SeznamProgramovaInstanceObj> {
        private seznamObj: SeznamProgramovaInstanceObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamProgramovaInstanceObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamProgramovaInstanceNew",
                contentCaption: "jres:29929931", //RC 33000681 : URL programov�ch f�z�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_ins}"
                },
                gridSettings: {
                    columnOrder: "zkratka,nazev,dat_zmena,zmenu_prov_txt,poznamka,faze,faze_txt,lic,typ_ag_ext_txt,priz_ext"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamProgramovaInstanceObj extends GAdmSeznamBase {
        faze: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailProgramovaInstance", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailProgramovaInstance",
                newRecord: isNew,
                ixs_ins: isNew == true ? null : data.ixs_ins,
                faze: isNew == true ? (this.faze ? this.faze : null) : null
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamKonfiguracniSkupina: {
                    caption: "jres:33000776", //RC 33000776 : Konfigura�n� skupiny instance
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actOpenSeznamKonfiguracniSkupina(false);
                    }
                },
                actOpenSeznamFunkcniMisto: {
                    caption: "jres:33000777", //RC 33000777 : Funk�n� m�sta instance
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actOpenSeznamKonfiguracniSkupina(true);
                    }
                },
                actHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance: {
                    caption: "jres:33000780", //RC 33000780 : Hromadn� p�i�adit konfigura�n� skupiny instanc�m
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance(false);
                    }
                },
                actHromadnaOperaceAdmFunkcniMistoProgramovaInstance: {
                    caption: "jres:33000781", //RC 33000781 : Hromadn� p�i�adit funk�n� m�sta instanc�m
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance(true);
                    }
                },
                actParametryProInstanci: {
                    caption: "jres:33000775",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actParametryInstance();
                    }
                },
                actDeleteEkoini: {
                    caption: "jres:33000782", //RC 33000782 : Vymazat ekoinicializaci instanc�
                    icon: "gi-settings",
                    run: (ev, ctx) => {
                        this.cnt.actions.actDeleteEkoini?.setPending(this.deleteEkoinit())
                    }
                },
                actDeleteAplSetting: {
                    caption: "jres:33000786", //RC 33000786 : Vymazat u�ivatelsk� nastaven� instanc�
                    icon: "gi-settings",
                    run: (ev, ctx) => {
                        this.cnt.actions.actDeleteAplSetting?.setPending(this.deleteAplSetting())
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actOpenSeznamKonfiguracniSkupina },
                    { action: this.cnt.actions.actOpenSeznamFunkcniMisto },
                    { action: this.cnt.actions.actParametryProInstanci },
                    { action: this.cnt.actions.actHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance },
                    { action: this.cnt.actions.actHromadnaOperaceAdmFunkcniMistoProgramovaInstance }
                ]
            }, {
                favorite: true, type: "static", caption: "jres:33000783", icon: "gi-settings", children: [  //RC 33000783 : Dal�� akce
                    { action: this.cnt.actions.actDeleteEkoini },
                    { action: this.cnt.actions.actDeleteAplSetting }
                ]
             }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "actOpenSeznamKonfiguracniSkupina*",
                "actOpenSeznamFunkcniMisto*",
                "actParametryProInstanci*",
                "actHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance*",
                "actHromadnaOperaceAdmFunkcniMistoProgramovaInstance*",
                "actDeleteEkoini*",
                "actDeleteAplSetting*"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131111").addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), {
                name: "faze",
                model: "model.faze=value.faze",
                dropdown: true,
                disabled: this.faze ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.faze)
                hardFilter["faze"] = this.faze;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.faze)
                data["faze"] = this.faze
        }

        applydata(filterData: any) {
            this.cnt.isl.ProgramovaInstance.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSeznamKonfiguracniSkupina?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamFunkcniMisto?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actParametryProInstanci?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance?.update({ enabled: objArr.count >= 1 })
            this.cnt.actions.actHromadnaOperaceAdmFunkcniMistoProgramovaInstance?.update({ enabled: objArr.count >= 1 })
            this.cnt.actions.actDeleteEkoini?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actDeleteAplSetting?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_ins}`,
                nazev: data["nazev"]
            }
        }

        private actOpenSeznamKonfiguracniSkupina(funkcniMisto: boolean) {
            var activeRow = this.grid.ggrid("activeRow")
            if (activeRow)
                $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmKonfiguracniSkupinaProgramovaInstance", {
                    ixs_ins: activeRow.ixs_ins,
                    typ_usr: funkcniMisto == true ? 10 : 0  // B�n� konfigura�n� skupina
                }])
        }

        private actHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance(funkcniMisto: boolean) {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        ixs_ins: item["ixs_ins"],
                        ixs_usr: null
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance"], { ID: "HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance", data: data, typ_usr: funkcniMisto == true ? 10 : 0 }, "", 1000, 600)
        }

        private actParametryInstance() {
            var activeRow = this.grid.ggrid("activeRow")
            if (activeRow)
                $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmParametrGlobal"], {
                    ID: "SeznamAdmParametrGlobal",
                    ixs_ins: activeRow.ixs_ins,
                    uroven_cfg: 40
                })
        }

        private deleteEkoinit(): JQueryPromise<undefined> {
            var _this = this;
            return $.Deferred(function () {
                var def = this;
                var selection = _this.grid.ggrid("getSelection");
                var instance = selection.map((item) => item.ixs_ins);
                _this.cnt.isl.ProgramovaInstance.deleteEkoinit({ instance: instance }).get().then((data) => {
                    var success: string[] = [];
                    var error: string[] = [];
                    selection.forEach((item) => {
                        if (data.findIndex(res => res == item.ixs_ins) != -1)
                            success.push(item.nazev);
                        else
                            error.push(item.nazev);
                    })
                    _this.cnt.notification("add", {
                        title: "jres:29929931",
                        icon: "fa-bookmark-o",
                        content: "jres:33000784".format(data.length, success.length > 0 ? `(${success.join(", ")})` : "", selection.length - data.length, error.length > 0 ? `(${error.join(", ")})` : "") //RC 33000784 : �sp�n� smazan� ekoinicializace: {0} {1}<br />Ne�sp�n� smazan� ekoinicializace: {2} {3}
                    });
                    return def.resolve().promise();
                }).catch(() => {
                    return def.reject().promise();
                });
            })
        }

        private deleteAplSetting(): JQueryPromise<undefined> {
            var _this = this;
            return $.Deferred(function () {
                var def = this;
                var selection = _this.grid.ggrid("getSelection");
                var instance = selection.map((item) => item.ixs_ins);
                _this.cnt.isl.ProgramovaInstance.deleteAplSettings({ instance: instance }).get().then((data) => {
                    var success: string[] = [];
                    var error: string[] = [];
                    selection.forEach((item) => {
                        if (data.findIndex(res => res == item.ixs_ins) != -1)
                            success.push(item.nazev);
                        else
                            error.push(item.nazev);
                    })
                    _this.cnt.notification("add", {
                        title: "jres:29929931",
                        icon: "fa-bookmark-o",
                        content: "jres:33000785".format(data.length, success.length > 0 ? `(${success.join(", ")})` : "", selection.length - data.length, error.length > 0 ? `(${error.join(", ")})` : "") //RC 33000785 : �sp�n� smazan� aplika�n� nastaven�: {0} {1}<br />Ne�sp�n� smazan� aplika�n� nastaven�: {2} {3}
                    });
                    return def.resolve().promise();
                }).catch(() => {
                    return def.reject().promise();
                })
            })
        }
    }
}